// Colours of the phone board that the theme has no token for. The approved
// mockup draws its cards, fields and sheets white on the grey page in the
// light theme (the theme's own `paper` is a grey that vanishes against the
// page there); in the dark theme paper is already the raised colour.

import { alpha, type Theme } from '@mui/material/styles';

/** The colour of a sheet, a field and a segmented control. */
export const surface = (theme: Theme) =>
    theme.palette.mode === 'light' ? '#ffffff' : theme.palette.background.paper;

/** Text and icon ink at a fraction of full strength, as the mockup states it. */
export const ink = (theme: Theme, opacity: number) =>
    alpha(theme.palette.text.primary, opacity);
